
import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    marginTop: 0,
    marginBottom: 0,
    border: 'none',
    fontSize: '12px'
  },
});

export const RTFOFracSimulatorDataTable = ({ darkMode, stressShadow, allStages }) => {

    // STYLES
    const classes = useStyles();

    const rows = useMemo(() => {
      if (!stressShadow || !allStages) return [];
      let data = [];

      allStages?.forEach((stageName, index) => {
        const ss = Number(stressShadow?.[stageName]?.toFixed(3) || 0);
        const stageNumber = Number(stageName?.split('_')?.[2]);
        const wellName = stageName?.split('_')?.[1];
        data.push({
          id: stageName,
          stageName,
          wellName,
          stageNumber,
          order: parseInt(index) + 1,
          stressShadow: ss
        });

      });

      return data;
    }, [stressShadow, allStages]);
  
  try {

    const columns = [
      {
        field: 'stageName',
        headerName: 'Stage Name',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'wellName',
        headerName: 'Well Name',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
        type: 'string'
      },
      {
        field: 'stageNumber',
        headerName: 'Stage Number',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true
      },
      {
        field: 'order',
        headerName: 'Order in Sequence',
        width: 150,
        editable: false,
        sortable: true,
        filterable: true,
      },
      {
        field: 'stressShadow',
        headerName: 'Stress Shadow (MPa)',
        width: 200,
        editable: false,
        sortable: true,
        filterable: true
      }
    ];


    return (
      <Paper className={classes.root} elevation={0}>
        <DataGrid
          density="compact"
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          sx={{
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: darkMode ? 'grey' : 'whitesmoke'
            }
          }}
          style={{fontSize: '12px'}}
        />
      </Paper>
    );
  } catch (error) {
    return <></>
  };
};

